import { createAction, props } from '@ngrx/store';
import { SalesPartner } from '@oneqrew-partnertool/models';

export const setFetchedSalesPartners = createAction('[Sales Partners API] Set Fetched Sales Partners', props<{ salesPartners: SalesPartner[] }>());
